export const config = {
    // API_URI: "https://zoobbe-board.onrender.com",
    // API_URI: "https://api-qcqo.onrender.com",

    // API_URI: "https://zoobbe-beta.onrender.com",
    // API_URI: "https://api-v1.zoobbe.com",
    // REACT_APP_API_URI lets an isolated test/dev build point at a specific
    // backend (e.g. the Dockerized test stack) without code changes. Unset in
    // production, so the existing origin-based logic is unchanged there.
    API_URI: process.env.REACT_APP_API_URI
        || (window.location.hostname === 'zoobbe.com'
            ? 'https://api.zoobbe.com'
            : `${window.location.origin}`),

    // API_URI: "http://localhost:5001",

    DOMAIN: typeof window !== 'undefined' ? window.location.origin : "https://zoobbe.com",
    IS_BETA: false,
    GOOGLE_CLIENT_ID: "39531044046-0lrtdc7ojrq119nhg7fq14t8m27ae0so.apps.googleusercontent.com",
    GITHUB_CLIENT_ID: "Ov23liUzCyNVGc0d98nY", // Replace with actual GitHub OAuth App Client ID
    PUSH_NOTIFICATION_VAPID_KEY_PAIR_ID: "BGeuQBwitmUXTSwhzhDt3xihBHyLDYSOZPXa7AXuIHWvK_7nv6bHM3WDDdlg_nMABtjigrQuOUN1iqmJtOcywkY",
    CLOUDFLARE_RECAPTCHA_SITE_KEY: "0x4AAAAAABCKhHsMLzF3gBUs",
    TRELLO_AUTH_API_KEY: "952269ee902bbd2a413c4890094365f2",
    STRIPE_PUBLIC_KEY: "pk_test_51Ldmn6K0cSs6yAeTLETj2DdPhCbbWMGy9lPEbMFF6POU8DODiJjMCEJgLrMfmN7WD3k96KkDs7nkQWK5UDPQANFp00aRx7H5Pn",
    FREE_COLLABORATORS_LIMIT: 15,
    APP_VERSION: "v1.1.0",
    // API_URI: "https://api.zoobbe.com",

    // Payment provider first-paint default ('stripe' | 'paddle'). The backend
    // (/v1/paddle/config) is the source of truth; this only avoids a flash
    // before that resolves. We only support Paddle right now, so default to it
    // (falling back to Stripe on a failed config fetch would render a broken
    // Stripe card form that errors on pay).
    PAYMENT_PROVIDER: 'paddle',

    // White Label Configuration
    DISABLE_WHITE_LABEL_PAYMENTS: false,

    // Global OAuth Configuration (for main Zoobbe domain)
    ENABLE_GOOGLE_AUTH: true, // Default: enabled for main Zoobbe domain
    ENABLE_GITHUB_AUTH: true, // Default: enabled for main Zoobbe domain
};
